import styled from 'styled-components';

import { Text } from '../../../../components/Text/Text';
import { COLORS, SPACE } from '../../../../theme/tokens';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

export const Intro = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACE[12]};
  color: ${COLORS.accent};
`;

export const Lead = styled(Text)`
  font-size: 15px;
  line-height: 1.5;
  color: ${COLORS.text};
`;

/** How long it takes, what players see meanwhile, the price. */
export const Facts = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  margin: 0;
  padding: ${SPACE[12]} 0 0;
  list-style: none;
  border-top: 1px solid ${COLORS.hairline};
`;

export const Item = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${SPACE[8]};
  font-size: 13.5px;
  line-height: 1.45;
  color: ${COLORS.textMuted};

  svg {
    flex: none;
    margin-top: ${SPACE[2]};
    color: ${COLORS.accent};
  }
`;
